<h2 mat-dialog-title>Solution</h2>
  <table style="width: 100%"><tr>
  <td style="width:100%">
    
  
    
   </td>
	<td><button mat-button class="w3-theme-l3" >中</button></td>
	<td><button mat-button class="w3-theme-l3" >EN</button></td>	
	</tr>
	</table>
<mat-dialog-content class="mat-typography">
  <img style="width:1000px;max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/v1580973860/question/{{data.question.folder_name}}/{{data.question.folder_name}}_Q{{data.question.question_no}}_{{data.lang}}_S.png">
         

 
</mat-dialog-content>
